import { gql } from '@grandvisionhq/graphql';

const SET_PASSWORD = gql`
  mutation ActivateCustomerAccount($input: ActivateAccountInput!) {
    activateCustomerAccount(input: $input) {
      customerId
    }
  }
`;

export { SET_PASSWORD };
//# sourceMappingURL=create-password.js.map
